import styled from "styled-components";

const ContentsEndBox = styled.div`

    margin-bottom:5px;
    text-align:end;
`;

export default ContentsEndBox;